export var SDK_VERSION = '6.19.7';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/core/esm/version.js
// module id = 816
// module chunks = 32 33 36